export default __webpack_public_path__ + "images/a866879ae8db61290e0814db06843f8e.png";